import React, {Component} from "react"
import {CheckboxGroup, Select} from 'formsy-react-components'
import {connect} from "react-redux"
import {injectIntl} from "react-intl"
import {queryApplications} from '../../dispatch'

function mapStateToProps(state, ownProps) {

  const applications = state.applications || {data:[]}
  return {
    applications
  }
}

const mapDispatchToProps = {
  queryApplications
}


class ApplicationCheckboxGroup extends Component {

  componentWillMount() {
    this.props.queryApplications()
  }

  render() {

    const data = this.props.applications.data
    const format = this.props.intl.formatMessage

    const options = data.filter((app)=>_.includes(['cogoland'], app.name)).map(
      (c)=>
        ({
          value: c.id,
          label: format({id:`application.name.${c.name}`})
        })
    )

    return (
      <CheckboxGroup name={this.props.name}
              label="Application"
              value={this.props.value?this.props.value:[2]}
              options={options}
              required={this.props.required}
              {...this.props}
      >
      </CheckboxGroup>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ApplicationCheckboxGroup))



// WEBPACK FOOTER //
// ./src/components/form/ApplicationCheckboxGroup.js